import { useTranslations } from "next-intl";

import { Link } from "@/i18n/routing";
import Button from "@/ui/Button";

import styles from "./styles.module.scss";

interface RecommendedListProps<T = any> {
  recommended: T[];
  recommendedLink?: string;
  title?: string;
  className?: string;
  showSeeAllButton?: boolean;
  children: (item: T, index: number) => React.ReactNode;
}

export function RecommendedList<T = any>({
  recommended,
  recommendedLink,
  title,
  className,
  showSeeAllButton = true,
  children,
}: RecommendedListProps<T>) {
  const t = useTranslations();

  if (!recommended?.length) {
    return null;
  }

  const sectionTitle = title || "You may be interested";

  return (
    <section className={className}>
      <h2 className={"object-detail__section-header mb-[3rem]"}>
        {t(sectionTitle)}
      </h2>
      <div className={styles.layoutsContainer}>
        {recommended.map((item, index) => children(item, index))}
      </div>
      {showSeeAllButton && recommendedLink && (
        <div className="flex mt-[4rem] xl:mt-[5rem]">
          <Link
            href={recommendedLink}
            className="w-full max-w-[25rem] m-auto"
          >
            <Button
              as="span"
              color="red"
              fullWidth
              radius="md"
              className="h-[5.4rem]"
            >
              {t("See all")}
            </Button>
          </Link>
        </div>
      )}
    </section>
  );
}
